const FILE = {
  REMOVE: 'FILE.REMOVE',
};

export { FILE as FILE_ACTION_TYPES };
